// Discover hub collection.
import { BRAND_LINKS, buildSupportMailto } from '../../configs/brandLinks';
import { collectionSection, defineCollection, text } from '../schema';
export const discoverCollection = defineCollection({
    id: 'collection:discover',
    kind: 'hub',
    route: '/discover',
    title: 'Discover',
    description: 'Learn more about our platform, games, music, and features.',
    seo: {
        description: 'Welcome to the Airhead Games knowledge base! Learn about our platform, games, music, and features. Explore what makes Airhead Games unique.',
    },
    hero: {
        title: [text('Discover')],
        description: [text('Your home for learning about Airhead Games.')],
        showDescription: true,
    },
    sections: [
        collectionSection({
            id: 'explore-platform',
            title: 'Explore Our Platform',
            description: 'Find out what makes Airhead Games unique and how we create engaging party game experiences for streamers and their communities.',
            widgets: [
                {
                    type: 'linkCardGrid',
                    items: [
                        {
                            title: 'Games',
                            collectionId: 'collection:games',
                        },
                        {
                            title: 'Features',
                            collectionId: 'collection:features',
                        },
                        {
                            title: 'Clips',
                            href: '/discover/clips',
                        },
                        {
                            title: 'Music',
                            href: '/discover/music',
                        },
                        {
                            title: 'Blog',
                            collectionId: 'collection:blog',
                        },
                    ],
                },
            ],
        }),
        collectionSection({
            id: 'support',
            title: 'Get Support',
            description: "Need help or have questions? Join Poppy's Pals Discord or email support.",
            widgets: [
                {
                    type: 'linkCardGrid',
                    items: [
                        {
                            title: 'Discord',
                            href: BRAND_LINKS.discord,
                        },
                        {
                            title: 'Email',
                            href: buildSupportMailto('Support Request'),
                        },
                    ],
                },
            ],
        }),
    ],
});
//# sourceMappingURL=discover.js.map